module.exports = __webpack_public_path__ + "static/media/vidrio_domiciliario.056e66d0.png";